module.exports = __webpack_public_path__ + "img/MAC1680_1-1.2901ea6b.jpg";